'use client'
import 'swiper/scss';
import 'swiper/scss/effect-fade';
import {Swiper,  SwiperSlide} from "swiper/react";
import {A11y, EffectFade} from "swiper/modules";
import React, {useEffect, useState} from "react";
import {CardProps} from "../types";
import {Card} from "../index";
import {styled} from "@phntms/css-components";
import {CardContainer, CardDecoration} from "../styles";
import type {Swiper as SwiperClass} from "swiper/types";
import {NextButton, PreviousButton} from "../../buttons/ControlButtons";
import styles from "./styles.module.scss";



export interface CarouselCardProps extends React.HTMLAttributes<HTMLDivElement> {
  decoration?: boolean;
  decorationColor?: string;
  decorationPosition?: 'left' | 'right';
  autoplay?: boolean;
  loop?: boolean;
  cards: CardProps[];
}

export const CarouselCardContainer = styled(CardContainer, {
  css: [styles.cardCarousel, 'card-carousel'],
  variants: {}
})


export const CarouselCard = ({
                               decoration,
                               decorationPosition,
                               decorationColor,
                               loop,
                               autoplay,
                               cards,
                               ...props
                             }: CarouselCardProps) => {
  const [swiper, setSwiper] = useState<any>();
  const [previousDisabled, setPreviousDisabled] = useState<any>(false);
  const [nextDisabled, setNextDisabled] = useState<any>(false);
  const modules = [A11y, EffectFade];


  const handleSwiper = (swiperInstance: SwiperClass) => {
    setSwiper(swiperInstance);
    setPreviousDisabled(swiperInstance.isBeginning);
    setNextDisabled(swiperInstance.isEnd);
    swiperInstance.on('activeIndexChange', () => {
      setPreviousDisabled(swiperInstance.isBeginning);
      setNextDisabled(swiperInstance.isEnd);
    });

  };
  const handlePrev = () => {
    swiper && swiper?.slidePrev();
  };

  const handleNext = () => {
    swiper && swiper?.slideNext();
  };

  const decorated = decoration || decorationPosition || decorationColor;

  return <CarouselCardContainer {...props}>
    {decorated &&
      <CardDecoration position={decorationPosition || 'left'} style={{backgroundColor: decorationColor || '#f7f7f7'}}/>}
    <Swiper onSwiper={handleSwiper}
            autoplay={autoplay}
            loop={loop}
            modules={modules}
            slidesPerView={1}
            allowTouchMove={true}
            effect={"fade"}>
      {cards.map( (card, i) => <SwiperSlide key={"slide"+i} > <Card {...card} /></SwiperSlide>)}
    </Swiper>
    <PreviousButton onClick={handlePrev} disabled={previousDisabled} />
    <NextButton onClick={handleNext} disabled={nextDisabled} />
  </CarouselCardContainer>

}
